import React from 'react';

import {
  useConcept,
  useUpdate,
  useIsUpdating,
} from 'scenes/Gallery/GalleryPage/Concepts/data';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

import EditConceptForm from './EditConceptForm';
import { getValidationSchema } from './schemas';

const EditConcept = ({ id, onSubmit, onClose, open, onExited }) => {
  const { data, isLoading } = useConcept({ id });
  const [updateConcept] = useUpdate();
  const isUpdating = useIsUpdating();
  const { isAllowJiraTask, isAllowConceptFamilies, isAllowRequestedBy } =
    useGalleryPermissions();
  const handleSubmit = async (values) => {
    await updateConcept(values);
    onSubmit();
  };

  return (
    <EditConceptForm
      loading={isLoading || isUpdating}
      validationSchema={getValidationSchema({
        isAllowJiraTask,
        isAllowConceptFamilies,
        isAllowRequestedBy,
      })}
      onClose={onClose}
      open={open}
      onExited={onExited}
      initialValues={data}
      onSubmit={handleSubmit}
      entityId={id}
    />
  );
};
export default EditConcept;
